module.exports = __webpack_public_path__ + "img/login-icon.0d11331f.svg";